import { Controller } from "@hotwired/stimulus"
import { OfflinePdfStore, offlineCopyExpired } from "../offline_pdf_store.js"

export default class extends Controller {
  static targets = ["connecting", "library", "list", "status"]
  static values = { userId: Number, labels: Object, rootUrl: String }

  async connect() {
    if (navigator.onLine) {
      window.location.replace(this.rootUrlValue)
      return
    }

    this.connectingTarget.hidden = true
    this.libraryTarget.hidden = false
    this.store = this.createStore()
    if (!this.store.supported()) {
      this.statusTarget.textContent = this.labelsValue.unsupported
      return
    }

    try {
      const ready = []
      for (const record of await this.store.list(this.userIdValue)) {
        if (offlineCopyExpired(record)) {
          await this.store.delete(record)
        } else if (record.ready && await this.store.verifyComplete(record)) {
          ready.push(record)
        }
      }

      this.statusTarget.textContent = ready.length ? "" : this.labelsValue.empty
      this.listTarget.replaceChildren(...ready.map((record) => this.card(record)))
    } catch (_error) {
      const store = this.store
      this.store = null
      await store.closeDatabase().catch(() => {})
      this.listTarget.replaceChildren()
      this.statusTarget.textContent = this.labelsValue.unsupported
    }
  }

  createStore() {
    return new OfflinePdfStore()
  }

  disconnect() {
    this.store?.closeDatabase()
  }

  card(record) {
    const article = document.createElement("article")
    article.className = "offline-library-card"
    const title = document.createElement("h2")
    title.textContent = record.book.title
    const status = document.createElement("p")
    status.textContent = this.labelsValue.ready
    const link = document.createElement("a")
    link.className = "button button--primary"
    link.href = record.readerUrl
    link.dataset.turbo = "false"
    link.textContent = this.labelsValue.open
    article.append(title, status, link)
    return article
  }
}
